/*
 *
 * QualitativeQuestionList reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_QUALITATIVE_ANSWERS_WATCHER,
  GET_QUALITATIVE_ANSWERS_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  isLoadingAnswers: true,
  answers: [],
})

function qualitativeQuestionListReducer(state = initialState, action) {
  switch (action.type) {
    case GET_QUALITATIVE_ANSWERS_WATCHER:
      return state.set("isLoadingAnswers", true).set("answers", [])

    case GET_QUALITATIVE_ANSWERS_SUCCESS:
      return state.set("isLoadingAnswers", false).set("answers", action.payload)

    default:
      return state
  }
}

export default qualitativeQuestionListReducer
